import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MotorvehiclesService } from './motorvehicles.service';
import * as CryptoJS from 'crypto-js';
import { CommonService } from '../../../../shared/common.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';
@Component({
  selector: 'app-motorvehicles',
  templateUrl: './motorvehicles.component.html',
  styleUrls: ['./motorvehicles.component.scss']
})
export class MotorvehiclesComponent implements OnInit{
  vehicleform: FormGroup; isJump: any;
  motorvehicleid: any;
  APPeriodId: any;
  tangibleAssetsValidation: any;
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, private vehicleservice: MotorvehiclesService, public commonService: CommonService, private router: Router, public sidenav: SideNavService) {
  }
  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.createvehicles();
    this.getvehicle(this.APPeriodId);
    this.isJump = localStorage.getItem('isJump')
    if (localStorage.getItem("SubmitStatus") == "true")
      this.vehicleform.disable()
    this.clearfield();
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true);
            this.getlastyeardata()
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
    }

  createvehicles() {
    this.vehicleform = this.formbuilder.group({
      APPeriodId: new FormControl(),
      MotorVehiclesId: new FormControl(),
      MasterId: new FormControl(),
      PropertyPlantEquipmentGrossCost_End: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_End: new FormControl(),
      PropertyPlantEquipment_Start: new FormControl(),
      PropertyPlantEquipment_End: new FormControl(),
      TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment: new FormControl(),
      DisposalsPropertyPlantEquipment: new FormControl(),
      AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start: new FormControl(),
      IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment: new FormControl(),
      PropertyPlantEquipmentGrossCost_Start: new FormControl(),
      PropertyPlantEquipmentFreeøtextComment: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.vehicleform.reset()
      }
    })
  }

  Insertvehicles() {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.vehicleform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.vehicleform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'))
    const formdata = this.vehicleform.getRawValue();
    if (this.motorvehicleid) {
      this.vehicleform.controls['MotorVehiclesId'].setValue(this.motorvehicleid)
    }
    this.vehicleservice.insertvehicle(formdata).subscribe((data) => {
      this.vehicleform.markAsPristine()
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Motor Vehicles", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'motorvehicles') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })

  }
  getvehicle(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.vehicleservice.getmotorvehicle(this.APPeriodId).subscribe((data:any) => {
      if (data) {
        this.vehicleform.patchValue(data);
        this.motorvehicleid = data.MotorVehiclesId
      }
      this.commonService.getNotesData();
      this.commonService.gettotaltanagable()
      this.vehicleform.controls['PropertyPlantEquipmentGrossCost_End'].disable();
      this.vehicleform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_End'].disable();
      this.vehicleform.controls['PropertyPlantEquipment_Start'].disable();
      this.vehicleform.controls['PropertyPlantEquipment_End'].disable();
      this.vehicleform.controls['TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment'].disable();
      this.vehicleform.controls['DisposalsPropertyPlantEquipment'].disable();
      this.vehicleform.controls['AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start'].disable();
      this.vehicleform.controls['IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.vehicleform.controls['DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment'].disable();
      this.vehicleform.controls['PropertyPlantEquipmentGrossCost_Start'].disable();
      this.costcalculations();
      this.depreciation();
    })
  }

  getlastyeardata() {
   
    this.vehicleservice.getmotorvehicleLY(this.APPeriodId).subscribe((data: any) => {
      debugger
      this.showBubbledata = data;
      
      this.vehicleform.controls['PropertyPlantEquipment_End'].setValue(data.PropertyPlantEquipment_End)

    })
  }

  save() {
    debugger
    //if (this.validations()) {
    if (true) {
      this.Insertvehicles();
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  back() {
    this.vehicleform.markAsPristine()
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Motor Vehicles", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  costcalculations() {
    //const propertyPlantEquipmentGrossCost_End = +this.vehicleform.get("PropertyPlantEquipmentGrossCost_Start").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_End = +this.vehicleform.get("TotalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment").value;
    //const propertyPlantEquipment_Start = +this.vehicleform.get("DisposalsPropertyPlantEquipment").value;
    //const total = propertyPlantEquipmentGrossCost_End + accumulatedDepreciationImpairmentPropertyPlantEquipment_End;
    //this.vehicleform.get("PropertyPlantEquipmentGrossCost_End").setValue(total - propertyPlantEquipment_Start);
    //this.vehicleform.get("PropertyPlantEquipment_Start").setValue(this.vehicleform.get("PropertyPlantEquipmentGrossCost_End").value - this.vehicleform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }
  depreciation() {
    //const totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment = +this.vehicleform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_Start").value;
    //const disposalsPropertyPlantEquipment = +this.vehicleform.get("IncreaseDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const accumulatedDepreciationImpairmentPropertyPlantEquipment_Start = +this.vehicleform.get("DisposalsDecreaseInDepreciationImpairmentPropertyPlantEquipment").value;
    //const total = totalAdditionsIncludingFromBusinessCombinationsPropertyPlantEquipment + disposalsPropertyPlantEquipment;
    //this.vehicleform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").setValue(total - accumulatedDepreciationImpairmentPropertyPlantEquipment_Start);
    //this.vehicleform.get("PropertyPlantEquipment_Start").setValue(this.vehicleform.get("PropertyPlantEquipmentGrossCost_End").value - this.vehicleform.get("AccumulatedDepreciationImpairmentPropertyPlantEquipment_End").value);
  }


  validations() {
    debugger
    if (((this.vehicleform.controls['PropertyPlantEquipment_Start'].value == "" || this.vehicleform.controls['PropertyPlantEquipment_Start'].value == null) ? 0 : parseFloat(this.vehicleform.controls['PropertyPlantEquipment_Start'].value))
      + this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_Start +
      this.commonService.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_Start + this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_Start != ((this.commonService.tangibleAssetsValidation.BalanceSheet_CY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_CY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_CY)) {
      Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.EndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.StartYear + " both values must match. ", 'warning')
      return false
    }
    if (((this.vehicleform.controls['PropertyPlantEquipment_End'].value == "" || this.vehicleform.controls['PropertyPlantEquipment_End'].value == null) ? 0 : parseFloat(this.vehicleform.controls['PropertyPlantEquipment_End'].value))
      + this.commonService.tangibleAssetsValidation.LandAndBuilding_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Plantmachinery_PropertyPlantEquipment_End +
      this.commonService.tangibleAssetsValidation.Officeequipment_PropertyPlantEquipment_End + this.commonService.tangibleAssetsValidation.Furniturefittings_PropertyPlantEquipment_End != ((this.commonService.tangibleAssetsValidation.BalanceSheet_LY == null || this.commonService.tangibleAssetsValidation.BalanceSheet_LY == undefined) ? 0 : this.commonService.tangibleAssetsValidation.BalanceSheet_LY)) {
      Swal.fire("Andica Accounts Production", "Sum of Net book value of Tangible Fixed Assets At " + this.commonService.LastyearEndDate + " is different from the value reported in Balance Sheet for Tangible Fixed Assets in year " + this.commonService.LastYear + " both values must match. ", 'warning')
      return false
    }
    else {
      return true
    }
    
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.vehicleform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          if (this.save())
            return true;
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
